// @flow weak

import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  login
}                           from '../../services/API';

const REQUEST_USER_LOGIN   = 'REQUEST_USER_LOGIN';
const REQUEST_USER_LOGOUT   = 'REQUEST_USER_LOGOUT';
const RECEIVED_USER_LOGIN  = 'RECEIVED_USER_LOGIN';
const ERROR_USER_LOGIN     = 'ERROR_USER_LOGIN';

type UserData = {
  login:            ?string,
  firstname:        string,
  lastname:         string,
  picture:          ?string,
  error_message:    ?string,
  isAuthenticated:  boolean
};

type UserInfoState = {
  isFetching:   boolean,
  data:         UserData,
  isConnected:  boolean,
  time:         ?string
};



const initialState: UserInfoState = {
  isFetching: false,
  data: {
    login:            null,
    firstname:        '',
    lastname:         '',
    picture:          null,
    error_message:    null,
    isAuthenticated:  localStorage.getItem('isAuthenticated')||false
  },
  isConnected: false,
  time: null
};

export default function user(
  state: UserInfoState = initialState,
  action: any
) {
  switch (action.type) {

  case 'REQUEST_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };

  case 'RECEIVED_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      data:       { ...action.data },
      isConnected: true, // set user connected when retreiving userInfos
      time:       action.time
    };

  case 'ERROR_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };

  case 'REQUEST_USER_LOGOUT':
    return {
      ...state,
      data:       { ...action.data },
      time:       action.time
    };


  default:
    return state;
  }
}


export function loginUser(user_name,password) {
  return (
    dispatch: (action: any) => any,
    getState: () => any
  ) => {
    if (shouldFetchUserLogin(getState())) {
      return dispatch(fetchUserLogin(user_name,password));
    }
    return false;
  };
}

export function logoutUser() {
  return (
    dispatch: (action: any) => any,
    getState: () => any
  ) => {
    return dispatch(requestLogout());
  };
}



function requestLogout(time: string = moment().format()) {
  return {
    type:       REQUEST_USER_LOGOUT,
    data: {isAuthenticated:'false'},
    isFetching: true,
    time
  };
}


function requestUserLogin(time: string = moment().format()) {
  return {
    type:       REQUEST_USER_LOGIN,
    isFetching: true,
    time
  };
}
function receivedUserLogin(data, time = moment().format()) {
  if(!data['isAuthenticated']){
    data['error_message'] = data['message'] || "Invalid Credentials"
  }
  return {
    type:       RECEIVED_USER_LOGIN,
    isFetching: false,
    data: data,
    time
  };
}
function errorUserLogin(time = moment().format()) {
  return {
    type:       ERROR_USER_LOGIN,
    isFetching: false,
    time
  };
}

function fetchUserLogin(user_name,password) {
  return dispatch => {
    dispatch(requestUserLogin(name));
      login(user_name,password)
        .then(
          data => dispatch(receivedUserLogin(data))
        )
        .catch(
          error => dispatch(errorUserLogin(error))
        );
  };  
}
function shouldFetchUserLogin(state) {
  const userInfosStore = state.userInfos;
  if (userInfosStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/user.js